'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Selectors


// Components


// Actions


// Utils


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _liveEditingUtilSelector = require('./liveEditingUtilSelector');

var _liveEditingUtilSelector2 = _interopRequireDefault(_liveEditingUtilSelector);

var _ToolButton = require('../../../../components/buttons/ToolButton');

var _ToolButton2 = _interopRequireDefault(_ToolButton);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _LiveEditingPopup = require('./LiveEditingPopup');

var _LiveEditingPopup2 = _interopRequireDefault(_LiveEditingPopup);

var _popupActions = require('../../../../components/popupPanel/popupActions');

var _userUtil = require('../../../../user/userUtil');

var _liveEditingUtilConstants = require('./liveEditingUtilConstants');

require('./LiveEditingUtil.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        openPopupPanel: function openPopupPanel() {
            return dispatch((0, _popupActions.togglePopup)(_liveEditingUtilConstants.LIVE_EDITING_POPUP_ID));
        }
    };
};

var LiveEditingUtil = function LiveEditingUtil(props) {
    var currentUser = props.currentUser,
        openPopupPanel = props.openPopupPanel,
        activeUserCount = props.activeUserCount,
        errorActiveUserIds = props.errorActiveUserIds,
        fetchingActiveUserIds = props.fetchingActiveUserIds;


    if ((0, _userUtil.isGuest)(currentUser)) return null;

    var active = !errorActiveUserIds.length && !fetchingActiveUserIds.length && activeUserCount > 0;

    return _react2.default.createElement(
        'div',
        { className: 'HeaderUtil' },
        _react2.default.createElement(_ToolButton2.default, {
            icon: _react2.default.createElement(_Icon2.default, { name: 'nav-antenna' }),
            className: (0, _classnames2.default)('LiveEditingUtil', { active: active }),
            onClickFn: openPopupPanel }),
        _react2.default.createElement(_LiveEditingPopup2.default, _extends({}, props, { active: active }))
    );
};

LiveEditingUtil.propTypes = {
    currentUser: _propTypes2.default.object,
    openPopupPanel: _propTypes2.default.func,
    activeUserCount: _propTypes2.default.number,
    errorActiveUserIds: _propTypes2.default.array,
    fetchingActiveUserIds: _propTypes2.default.array
};

exports.default = (0, _reactRedux.connect)(_liveEditingUtilSelector2.default, mapDispatchToProps)((0, _recompose.pure)(LiveEditingUtil));


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/liveEditing/LiveEditingUtil.js
// module id = 2185
// module chunks = 0